import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { Icon, StyledButton } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import QrMobileAppImg from "images/qr-mobileapp@2x.png";

interface MobileAppPromotionContentProps {
  onClose: () => void;
}

const MobileAppPromotionContent: React.FC<MobileAppPromotionContentProps> = ({ onClose }) => {
  const onReadMoreClick = () => {
    window.open("https://faq.wint.se/nyhet/nya-wint-appen-ar-har", "_blank", "noopener,noreferrer");
  };

  return (
    <Grid container rowGap={2}>
      <Grid item className={cssExports.walkingManContent}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MobileAppPromotion.Body)}
      </Grid>
      <Grid item className={cssExports.mobileAppQrCodes}>
        <img src={QrMobileAppImg} alt="" style={{ maxWidth: "200px" }} />
      </Grid>
      <Grid item className={cssExports.mobileAppDisclaimer}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MobileAppPromotion.Disclaimer)}
      </Grid>
      <Grid item container columnGap={1} direction="row" wrap="nowrap">
        <Grid item>
          <StyledButton size="xs" className={cssExports.smallbtn} onClick={onClose}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MobileAppPromotion.CloseButton)}
          </StyledButton>
        </Grid>
        <Grid item>
          <StyledButton
            size="xs"
            className={cssExports.smallbtn}
            onClick={onReadMoreClick}
            endIcon={<Icon icon={IconDefinitionConstants.WOpenExternal} />}
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.MobileAppPromotion.ReadMoreButton)}
          </StyledButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MobileAppPromotionContent;
